<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_4"><i>Dedicated to the One True Sovereign</i></a></p><a id="page_4">
<p class="dedi1"><i>To serve as a visual reminder of the consequences when</i></p>
<p class="dedi1"><i>mankind persists in a course of rebellion against His rulership</i></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Decication.vue?703a201f